<template lang="html">
  <div>
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-actions>
            <v-row>
              <v-col
                cols="3"
                class="pb-0"
              >
                <v-text-field
                  v-model="search"
                  placeholder="Key in name here"
                  append-icon="fas fa-search"
                  label="Search"
                  hide-no-data
                  hide-selected
                  clearable 
                />
              </v-col>
              <v-spacer />

              <v-col
                cols="2"
                class="pb-0"
              >
                <quality-management-dialog-create
                  v-if="!loading && (($hasPermissionTo(['upload quality management document']) && navItems.length > 1 && auth.department_id === navItems[navItems.length-1].department) || ($hasPermissionTo(['upload quality management document']) && navItems.length > 1))"
                  :parent="navItems[navItems.length-1]"
                  @created="reloadForms"
                />
              </v-col>

              <v-col
                cols="2"
                class="pb-0"
              >
                <quality-management-dialog-upload
                  v-if="!loading && (($hasPermissionTo(['upload quality management document']) && navItems.length > 1 && auth.department_id === navItems[navItems.length-1].department) || ($hasPermissionTo(['upload quality management document']) && navItems.length > 1))"
                  :parent="navItems[navItems.length-1]"
                  @uploaded="reloadForms"
                />
              </v-col>
            </v-row>
          </v-card-actions>

          <v-breadcrumbs
            :items="navItems" 
            divider="/"
          >
            <template v-slot:item="props">
              <a
                @click="loadFormsBackward(props.item)"
              >{{ props.item.text }}</a>
            </template> 
          </v-breadcrumbs>

          <v-row class="mx-2">
            <v-col cols="12">
              <v-data-table
                :items="qualityManagements"
                :items-per-page="10"
                :headers="headers"
                :loading="loading"
                :search="search"
              >
                <template v-slot:item="props">
                  <tr>
                    <td>
                      <div
                        v-if="['pdf'].includes(props.item.name.split('.').pop())"
                        class="clickable"
                        @click="openNewTab(props.item)"
                      >
                        <v-icon color="red">
                          mdi-file-pdf
                        </v-icon>
                        <a class="font-weight-bold black--text ml-1 text-uppercase">
                          {{ props.item.name }}                      
                        </a>
                      </div>
                     
                      <div
                        v-else-if="['docx','doc'].includes(props.item.name.split('.').pop())"
                        class="clickable"
                        @click="openNewTab(props.item)"
                      >
                        <v-icon color="blue">
                          mdi-file-document
                        </v-icon>
                        <a class="font-weight-bold black--text ml-1 text-uppercase">
                          {{ props.item.name }}                      
                        </a>
                      </div>

                      <div
                        v-else-if="['xls','xlsx','csv'].includes(props.item.name.split('.').pop())"
                        class="clickable"
                        @click="openNewTab(props.item)"
                      >
                        <v-icon color="green">
                          mdi-file-excel
                        </v-icon>
                        <a class="font-weight-bold black--text ml-1 text-uppercase">
                          {{ props.item.name }}                      
                        </a>
                      </div>

                      <div
                        v-else-if="['JPG','jpg','JPEG','jpeg','PNG','png'].includes(props.item.name.split('.').pop())"
                        class="clickable"
                        @click="openNewTab(props.item)"
                      >
                        <v-icon color="teal">
                          mdi-image
                        </v-icon>

                        <a class="font-weight-bold black--text ml-1 text-uppercase">
                          {{ props.item.name }}                      
                        </a>
                      </div>

                      <!-- <div
                        v-else-if="['MP4', 'mp4', 'WEBM', 'webm', 'MKV', 'mkv'].includes(props.item.name.split('.').pop())"
                        class="clickable"
                        @click="openNewTab(props.item)"
                      >
                        <v-icon color="teal">
                          mdi-video
                        </v-icon>

                        <a class="font-weight-bold black--text ml-1 text-uppercase">
                          {{ props.item.name }}                      
                        </a>
                      </div> -->

                      <div
                        v-else
                        class="clickable"
                        @click="loadFormsForward(props.item)"
                      >
                        <v-icon color="teal">
                          {{ props.item.is_private? 'far fa-folder':'far fa-folder-open' }} 
                        </v-icon> 
                        <a class="font-weight-bold black--text ml-1 text-uppercase">
                          {{ props.item.name }}                      
                        </a>
                      </div>
                    </td>

                    <td>
                      <span v-if="props.item.created_by">CREATED by {{ props.item.created_by }} </span>
                    </td>

                    <td>
                      <quality-management-dialog-delete
                        v-if="!loading && ($hasPermissionTo(['upload quality management document']) && navItems.length > 1 && auth.department_id === navItems[navItems.length-1].department || ($hasPermissionTo(['upload quality management document']) && navItems.length > 1))"
                        :quality-management="props.item"
                        :parent-id="navItems[navItems.length-1].id"
                        @deleted="reloadForms"
                      />
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  export default {
    components: {
      QualityManagementDialogCreate: () => import('@/components/quality-management/DialogCreate'),
      QualityManagementDialogUpload: () => import('@/components/quality-management/DialogUpload'),
      QualityManagementDialogDelete: () => import('@/components/quality-management/DialogDelete'),
    },

    data () {
      return {
        qualityManagements: [],
        search: null,
        navItems: [
          {
            id: 0,
            text: 'Home',
            increment: 1,
          },
        ],
        loading: false,
        headers: [
          { text: 'Folder', sortable: false, value: 'name' },
          { text: '', sortable: false, value: 'prepared_by' },
          { text: '', sortable: false, value: 'action' },
        ],
        auth: {},
      }
    },

    computed: {
      ...mapState({ user: 'currentUser', employee: 'currentEmployee' }),
    },

    created () {
      this.loadForms(0)
      
      this.$api.employees().show(this.employee.employee_uid)
        .then(response => {
          this.auth = response.data
        })
    },
    methods: {
      loadFormsForward (qualityManagement) {
        if (qualityManagement.id !== 0) {
          let exists = this.navItems.some(item => {
            return item.id === qualityManagement.id 
          })
          
          if (!exists) {
            this.navItems.push({ 
              id: qualityManagement.id,
              text: qualityManagement.name,
              increment: this.navItems.length + 1,
              department: qualityManagement.department_id, 
              is_private: qualityManagement.is_private,
            }) 
          }
        }

        this.loadForms(qualityManagement.id)
      },

      loadFormsBackward (qualityManagement) {
        this.navItems = this.navItems.filter(navItem => {
          return navItem.increment <= qualityManagement.increment
        })

        this.loadForms(qualityManagement.id)
      },

      loadForms (id) {
        this.loading = true

        this.$api.myQualityManagement().list(id)
          .then(res => {
            this.qualityManagements = _.orderBy(res.data, [file => file.file_path === null, file => file.name.toLowerCase()], ['desc', 'asc'])

            this.loading = false
          })
      },

      reloadForms (data) {
        this.loadForms(data.parent)
      },

      openNewTab (document) {
        window.open(document.file_url)
      }, 
    },
  }
</script>

<style scoped>
.clickable{
  cursor:pointer
}
</style>
